import { ImageWithPlaceholder, Typography } from '@wbk/ui';
import { type WebSection } from '@wbk/contentful/api';
import HeroTitle from '@/components/ui/HeroTitle';

type Props = {
  section?: WebSection;
};

const HeroSection = ({ section }: Props) => {
  return (
    <>
      <div className='relative h-[95dvh]'>
        <div className='absolute inset-0'>
          <div className='pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent via-black/40 to-black/80 mix-blend-multiply' />
          <ImageWithPlaceholder
            alt='explore hero'
            className='h-full w-full object-cover'
            src={section?.sectionBackground?.url}
          />
        </div>
        <div className='container-padding container h-full w-full'>
          <div className='container relative flex h-full w-full flex-col gap-4'>
            <div className='absolute inset-x-0 bottom-20 px-3 xl:px-0'>
              <div className='flex h-full w-full grid-cols-2 flex-col justify-between gap-6 sm:gap-6 lg:grid'>
                <div className='space-y-6 lg:space-y-10 rtl:space-y-4'>
                  {section?.title && <HeroTitle className='uppercase' title={section?.title} />}
                </div>

                <div className='flex h-full max-w-2xl flex-col justify-between gap-4 space-y-2 py-2 text-[#A1A1AA]'>
                  <Typography as='p' className='!text-body-S xl:!text-body-M 2xl:!text-body-L'>
                    {section?.subtitle && section?.subtitle}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeroSection;
